module.exports = __webpack_public_path__ + "static/media/Mastercard.28fe8977.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/bank/Mastercard.png
// module id = 291
// module chunks = 0